
import { useReducer } from 'react'
import { Pptos } from '../models/pptos'
import { pptosReducer } from '../reducers/pptosReducer'
import { Model } from '../models/model'

const initialState = {
    pptos: [],
    templates: [],
    detailTemplate: {},
    motivosList: []
}

export const usePptos = () => {

    const [state, dispatch] = useReducer(pptosReducer, initialState)
    const { pptos, templates, detailTemplate, motivosList } = state

    const initExport = async (filters) => {
        await Pptos.getExport(filters)
    }

    const initExportNegocios = async (filters) => {
        await Pptos.getExportNegocios(filters)
    }

    const initExportCliente = async (params) => {
        await Pptos.getExportCliente(params)
    }

    const initGetTemplates = async () => {
        const data = await Pptos.getTemplates()

        const action = {
            type: '[PPTOS] Load templates',
            payload: data
        }

        dispatch(action)
    }

    const initGetDataTemplate = async (budgetId) => {
        const data = await Pptos.getDataTemplate(budgetId)

        const action = {
            type: '[PPTOS] Get Data template',
            payload: data
        }

        dispatch(action)
    }

    const initRemoveTemplates = async (id) => {

        const resultDelete = await Model.delete({
            url: `templates/delete/${id}`
        })

        if (resultDelete) {
            const listUpdated = templates.filter(t => t.id !== id)
            const action = {
                type: '[PPTOS] Load templates',
                payload: listUpdated
            }
            dispatch(action)
        }

    }

    const initGetMotivos = async () => {
        const data = await Pptos.getMotivosAnulacion()

        const action = {
            type: '[PPTOS] Get Motivos',
            payload: data
        }

        dispatch(action)
    }

    return {
        pptos,
        templates,
        detailTemplate,
        motivosList,

        initExport,
        initExportCliente,
        initExportNegocios,

        initGetTemplates,
        initGetDataTemplate,
        initRemoveTemplates,

        initGetMotivos
    }

}